import * as Cesium from "cesium";
import { MarkerEntityType } from "./MarkerEntityType";

export function generateMarkerTooltip(
  coordinates: number[],
  text: string,
  pixelOffset: Cesium.Cartesian2,
): Cesium.Entity {
  return new Cesium.Entity({
    position: Cesium.Cartesian3.fromDegrees(coordinates[0], coordinates[1]),
    billboard: {
      image: generateMarkerTooltipCanvas(text),
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
      pixelOffset,
      verticalOrigin: Cesium.VerticalOrigin.CENTER,
    },
    properties: {
      type: MarkerEntityType.Tooltip,
    },
  });
}

function generateMarkerTooltipCanvas(textContent: string): HTMLCanvasElement {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.font = "16px sans-serif";

  const x = 0;
  const y = 0;
  const padding = 30;
  const width = ctx.measureText(textContent).width + padding;

  const height = 40;
  canvas.width = width;

  const triangleH = 10;
  canvas.height = height + triangleH;
  const r = 10;

  ctx.strokeStyle = "rgb(0, 0, 0)";
  ctx.fillStyle = "rgb(255,255, 255)";

  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + width - r, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + r);
  ctx.lineTo(x + width, y + height - r);
  ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);

  ctx.lineTo(x + width / 2 + triangleH / 2, y + height);
  ctx.lineTo(x + width / 2, y + height + triangleH);
  ctx.lineTo(x + width / 2 - triangleH / 2, y + height);
  ctx.lineTo(x + r, y + height);

  ctx.quadraticCurveTo(x, y + height, x, y + height - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();

  ctx.fill();
  ctx.stroke();

  ctx.fillStyle = "black";
  ctx.textAlign = "center";
  ctx.font = "16px sans-serif";
  ctx.fillText(textContent, width / 2, height / 2 + 6);
  return canvas;
}
